package es.subastia.domain.usecase

import es.subastia.domain.model.SavedSearchModel
import es.subastia.domain.repository.SavedSearchRepository
import kotlinx.coroutines.flow.Flow

class SaveSearchUseCase(private val repository: SavedSearchRepository) {
    suspend operator fun invoke(savedSearch: SavedSearchModel) {
        repository.saveSearch(savedSearch)
    }
}

class GetSavedSearchesUseCase(private val repository: SavedSearchRepository) {
    operator fun invoke(userId: String): Flow<List<SavedSearchModel>> {
        return repository.getSavedSearches(userId)
    }
}

class DeleteSearchUseCase(private val repository: SavedSearchRepository) {
    suspend operator fun invoke(searchId: String, userId: String) {
        repository.deleteSearch(searchId, userId)
    }
}
